import { SHIFTS } from "@/constants/shifts";
import { percentOf } from "@/components/report/shared/takenMath";

/** Jedna ćelija "preuzeto / poručeno" sa procentom. */
export const takenCell = (ordered, taken) => ({
  ordered,
  taken,
  percent: percentOf(taken, ordered),
  complete: ordered > 0 && taken >= ordered,
});

/**
 * Red tabele "preuzeto / poručeno" po smenama iz stavke starog taba (`shift1`…`shift4`: { quantity, quantity_payed }).
 * @param {object} item stavka (obrok ili firma) sa shift1..shift4, total i total_payed
 */
export const toTakenRow = (item, key, name) => {
  const cells = {};
  SHIFTS.forEach((shift) => {
    const data = item[`shift${shift.id}`] || {};
    cells[shift.id] = takenCell(Number(data.quantity) || 0, Number(data.quantity_payed) || 0);
  });
  const ordered = Number(item.total) || 0;
  const taken = Number(item.total_payed) || 0;
  return { key, name, ordered, taken, ...takenCell(ordered, taken), cells };
};

/** Odeljak tabele: redovi i zbir (preuzeto / poručeno) po redovima. */
export const toTakenSection = (key, name, rows) => {
  const ordered = rows.reduce((sum, row) => sum + row.ordered, 0);
  const taken = rows.reduce((sum, row) => sum + row.taken, 0);
  return { key, name, ordered, taken, ...takenCell(ordered, taken), rows };
};

/** Smene 1–3 uvek (ako su izabrane), četvrta samo kad neki red ima poručeno u njoj. */
export const visibleTakenShifts = (selected, sections) =>
  SHIFTS.filter(
    (shift) =>
      selected.includes(shift.id) &&
      (shift.id < 4 || sections.some((section) => section.rows.some((row) => row.cells[shift.id].ordered > 0)))
  );

/** Brojke u zaglavlju izveštaja "preuzeto" (bez preuzetog kad firma ne sme da vidi preuzimanje). */
export const takenKpis = (t, { sections, showTaken, countLabel, count }) => {
  const ordered = sections.reduce((sum, section) => sum + section.ordered, 0);
  const taken = sections.reduce((sum, section) => sum + section.taken, 0);
  if (!showTaken) {
    return [
      { key: "ordered", label: t("report_desktop.total_meals"), value: ordered, tone: "inverse" },
      { key: "count", label: countLabel, value: count },
    ];
  }
  return [
    { key: "taken", label: t("taken"), value: taken, of: ordered, percent: percentOf(taken, ordered), tone: "inverse" },
    { key: "count", label: countLabel, value: count },
    { key: "left", label: t("report_desktop.remaining"), value: Math.max(0, ordered - taken), tone: "accent" },
  ];
};
